import { useInstanceEffect } from '@/scenarios/legacy-player/hooks/useInstanceEffect';

export const useOnPlaybackRateChange = (callback: (playerPlaybackRate?: number) => void) =>
    useInstanceEffect((instance) => instance.onPlaybackRateChange(callback), [callback]);
